function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Camada_1-2",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "1243.29 855.61 1243.29 466.24 1102.66 466.24 1102.66 381.61 1480.45 381.61 1480.45 466.24 1340.79 466.24 1340.79 855.61 1243.29 855.61"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1539.98,
  y: 381.61,
  width: 97.5,
  height: 474
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2080.27,799.62q-26.39,35.71-60,52.45t-79,16.74q-99.43,0-161.06-69t-61.62-181.33q0-113.26,61.46-181.17t163.79-67.9q89.13,0,145.45,42.64t66.94,117.29h-99.44q-9-37-36.84-56.31t-72.57-19.31q-59.53,0-93.48,43.6t-34,120.52q0,77.22,35.4,121t97.18,43.77q46.34,0,77.56-27.36t38.61-75H1961.21V599.14H2157.5V855.61h-65.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2483.51,381.59H2370.87l-168.62,474h102.66l31.19-97.5h183.76l32.19,97.5h102.31Zm-121.68,296.7,65.65-201.74,66,201.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3115.81,692.79q-5.47,80.78-62.27,128.39t-148.18,47.63q-105.22,0-163.64-65.65t-58.4-184.07q0-121,59.53-185.35t171.2-64.36q90.73,0,143.36,44.25t57.76,125H3019q-6.12-40.22-32.82-61.3t-72.08-21.08q-64.37,0-97.83,41.52t-33.47,121.31q0,77.24,33.31,119.39t94.77,42.16q44.4,0,72.72-22.69t36.69-65.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3426,381.59H3313.38l-168.62,474h102.66l31.24-97.5h183.72l32.18,97.5h102.31Zm-121.63,296.7,65.66-201.74,66,201.74Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "3645.81 855.61 3645.81 381.61 3743.31 381.61 3743.31 768.08 3974.68 768.08 3974.68 855.61 3645.81 855.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "4028.1 855.61 4028.1 381.61 4125.61 381.61 4125.61 768.08 4356.98 768.08 4356.98 855.61 4028.1 855.61"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M662.55,688.08V498.7L816.26,390,961.39,287.42l38.14-27-20.76-29.8A540.76,540.76,0,0,0,790.29,63.08a537.19,537.19,0,0,0-505.6,0c-64,34.17-122,80.75-167.53,137.37h0l-21,30.2C33.23,320.84,0,427,0,537.54a539.58,539.58,0,0,0,16.09,131A533.63,533.63,0,0,0,61.78,788a542,542,0,0,0,149.1,176.47v273.76l247.14-169a543.19,543.19,0,0,0,79.47,5.86c111,0,217.49-33.52,308-97l32.38-22.65L712.06,754.13,684.8,771.32A275,275,0,0,1,574,811.4V748.67ZM537.49,73.16a464.72,464.72,0,0,1,359.38,170.3L803.3,309.57l-.6.45a349.36,349.36,0,0,0-530.43.05l-94.22-66.61A465,465,0,0,1,537.49,73.16ZM500.93,748.67V811.4c-135.14-18-239.74-133.95-239.74-273.86a274.57,274.57,0,0,1,29.75-124.71L412.43,498.7V688.08ZM695.62,849.19l74.45,90.35a465.81,465.81,0,0,1-314.13,55.17l-14.75-2.63L284,1099.56V927.12l-15.35-10.93C146.22,829.08,73.11,687.53,73.11,537.54a461.23,461.23,0,0,1,63.17-234l94.42,66.7a349.52,349.52,0,0,0,464.92,479ZM537.49,685.05l-51.9-35.57V460.8L332.32,352.53a276.3,276.3,0,0,1,410.34-.1L589.39,460.85V649.48Z"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4356.98 1238.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a875883.svg";
export { ForwardRef as ReactComponent };